import React from 'react'

const RehabPayment = ({ setSubComponent }) => {
  const handlePayment = () => {
    console.log('Payment clicked')
  }

  const handleUploadReceipt = () => setSubComponent("PaymentReceipt")

  return (
    <div>
      <div className="flex gap-3 mt-4">
        <button
          onClick={handlePayment}
          className="px-5 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 active:bg-blue-800 transition-colors cursor-pointer"
        >
          Payment
        </button>
        <button
          onClick={handleUploadReceipt}
          className="px-5 py-2.5 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 active:bg-green-800 transition-colors cursor-pointer"
        >
          Upload Payment Receipt
        </button>
      </div>
    </div>
  )
}

export default RehabPayment;